var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
        'custom-navbar__item inline-flex items-center bg-transparent border-0',
        'px-2 py-1.5 text-sm font-bold transition-opacity duration-200',
        _vm.active ? 'active opacity-100' : 'opacity-70 hover:opacity-100'
    ],attrs:{"type":"button"},on:{"click":_vm.onClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }